module.exports = require("-!babel!./../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./uploader.vue")

if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function" ? module.exports.options : module.exports).template = require("-!vue-html-loader!./../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./uploader.vue")
if (module.hot) {
(function () {
var hotAPI = require("vue-hot-reload-api")
hotAPI.install(require("vue"))
if (!hotAPI.compatible) return
var id = "-!babel!./../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./uploader.vue"
hotAPI.createRecord(id, module.exports)
module.hot.accept(["-!babel!./../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./uploader.vue","-!vue-html-loader!./../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./uploader.vue"], function () {
var newOptions = require("-!babel!./../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./uploader.vue")
if (newOptions && newOptions.__esModule) newOptions = newOptions.default
var newTemplate = require("-!vue-html-loader!./../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./uploader.vue")
hotAPI.update(id, newOptions, newTemplate)
})
})()
}


/*****************
 ** WEBPACK FOOTER
 ** ./components/uploader/uploader.vue
 ** module id = 125
 ** module chunks = 0
 **/